import Vue from 'vue';
import startCase from 'lodash/startCase';

Vue.filter('startCase', string => startCase(string));
